import { render, staticRenderFns } from "./TagsInputForm.vue?vue&type=template&id=76fd627b&scoped=true&"
import script from "./TagsInputForm.vue?vue&type=script&lang=js&"
export * from "./TagsInputForm.vue?vue&type=script&lang=js&"
import style0 from "./TagsInputForm.vue?vue&type=style&index=0&id=76fd627b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fd627b",
  null
  
)

export default component.exports